import PropTypes from 'prop-types'

import { useStyles } from './styles'
import { Text } from 'components/atoms'
import { ProductTile } from 'components/molecules'

export const RelatedProducts = ({ data }) => {
  const classes = useStyles()

  const renderGrid = (products) => {
    return products.map((product) => {
      return <ProductTile data={product} key={product.id} />
    })
  }

  return (
    <div className={classes.wrapper}>
      <Text size="header1" tag="h2" className={classes.title}>
        ADDITIONAL GOODIES
      </Text>
      <div className={classes.gridContainer}>{renderGrid(data)}</div>
    </div>
  )
}

RelatedProducts.propTypes = {
  data: PropTypes.array,
}

RelatedProducts.defaultProps = {
  data: null,
}
